import { usePageTitle } from "@/hooks/usePageTitle";
import { PeopleSearchPage } from "@/components/peopleSearch";

const PeopleSearch = () => {
	usePageTitle("People Search");
	return <PeopleSearchPage />;
};

export default PeopleSearch;
